import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-choose-equipment',
  templateUrl: './choose-equipment.component.html',
  styleUrls: ['./choose-equipment.component.scss']
})
export class ChooseEquipmentComponent implements OnInit {
  @Input() attractScreenEqListWrap: any;
  @Input() consoleType: string;
  @Output() imageDetailsUpdated = new EventEmitter();
  constructor(private commonUtil: CommonUtil) { }

  ngOnInit(): void {
    this.onSelectAllEqGrp(true);
  }

  getEqImageUrl(modelId: string) {
    return this.commonUtil.imgSrcGenerate(modelId, this.consoleType);
  }

  onSelectAllEqGrp(value: boolean) {
    this.attractScreenEqListWrap.checkedAll = value;
    this.attractScreenEqListWrap.uncheckedAll = value === false;
    this.attractScreenEqListWrap.attractScreenEquipList.forEach((a: any) => this.onSelectAllEq(a, value, false));
  }

  onSelectAllEq(groupEq: any, value: boolean, checkParent: boolean) {
    groupEq.checkedAll = value;
    groupEq.attractScreenAssetsList.forEach((e: any) => this.onSelect(undefined, e, value));
    if(checkParent) this.checkAllGroup();
  }

  onSelect(groupEq: any, eq: any, value: boolean) {
    eq.checked = value;
    if(groupEq) {
      let isAllcheck = groupEq.attractScreenAssetsList.every((e: any) => e.checked);
      if(isAllcheck !== groupEq.checkedAll) {
        groupEq.checkedAll = isAllcheck;
        this.checkAllGroup();
      }
    }
    this.attractScreenEqListWrap.uncheckedAll = this.attractScreenEqListWrap.attractScreenEquipList.every((a:any) => {
      return a.attractScreenAssetsList.every((e: any) => !e.checked);
    });
  }

  checkAllGroup() {
    let isAllcheck = this.attractScreenEqListWrap.attractScreenEquipList.every((e: any) => e.checkedAll);
    if(isAllcheck !== this.attractScreenEqListWrap.checkedAll) {
      this.attractScreenEqListWrap.checkedAll = isAllcheck;
    }
  }
}
